import angular from 'angular';

angular.module('cloudX').filter('userName', ['dataCache', userName]);

function userName(dataCache) {
  return function(userId) {
    if (!userId || userId === '00000000-0000-0000-0000-000000000000') return '';
    var user = dataCache.getObject('user')?.[userId];
    if (!user) return '';
    return ((user.firstName || '') + ' ' + (user.lastName || '')).trim();
  };
}
